/* eslint-disable max-statements */
/* eslint-disable no-use-before-define */
import axios from 'axios';
import Vue from 'vue/dist/vue.esm.js';
import { camelizeKeys } from 'humps';

const config = {
  duration: 5000,
  position: 'top',
  queue: true,
  dismissible: true,
  pauseOnHover: true,
}

const SERVER_ERROR_CODE = 500;
export default function setup() {
  axios.interceptors.response.use((response) => {
    if (response.data && response.data.is_success === false) {
      const message = response.data.messages || response.data.message

      if (!response.config?.skipErrorToast && message) {
        Vue.$toast.open({ message: `<b class="fs-6">Ops!</b><br>${message}`, type: 'error', ...config });
      }
      const error = new Error(message);
      error.response = response; // Mantener la respuesta original en el error
      return Promise.reject(error);
    }
    return response;
  },(err) => {
    let text;
    const status = err.response?.status
    const data = err.response?.data

    if (data) {
      const { humanMessage, errors } = camelizeKeys(data);
      text = getErrorMessages(errors) || humanMessage;
    }

    if (!text) {
      if (status >= SERVER_ERROR_CODE) {
        text = 'Algo ha ocurrido con el servidor. <a href="/">Refresca</a> tu navegador';
      } else if (status && status !== 401) {
        text = 'Has ingresado información no válida. Intenta nuevamente.';
      } else if (!status) {
        text = 'No pudimos ejecutar la solicitud. Intenta nuevamente.';
      }
    }

    if (text && !err.config?.skipErrorToast) {
      Vue.$toast.open({ message: `<b class="fs-6">Ops!</b><br>${text}`, type: 'error', ...config });
    }

    return Promise.reject(err);
  });
}

function getErrorMessages(errors) {
  let text = '';
  if (errors) Object.values(errors).forEach((e) => text += e.join(', '));

  return text;
}
